module.exports = __webpack_public_path__ + "img/wave-top.aa9081f9.svg";